import React from "react";
import { makeStyles } from "@mui/styles";
import { useHistory } from "react-router-dom";
import PropTypes from "prop-types";
import Typography from "@mui/material/Typography";
import { SubmitButton } from "@limitless/customer/components";
import ClientContext from "@limitless/common/utils/client-context/ClientContext";

import { useCustomerContext, useCustomerMessageContext } from "@limitless/customer/hooks";
import { CREATE, VERIFY } from "@limitless/libraries/src/portal/utils/ReContactMessageConstant";
import { useTranslation } from "@limitless/common/hooks/translation/TranslationContext";

const useStyles = makeStyles({
    container: {
        padding: "14px",
        alignItems: "center",
        flexDirection: "column",
        justifyContent: "center",
        backgroundColor: "#fff",
        boxShadow: "0px 2px 6px -2px rgba(0, 0, 0, 0.06)",
        borderRadius: "16px"
    },
    heading: {
        textAlign: "center",
        fontSize: "14px",
        fontStyle: "normal",
        fontWeight: 400,
        lineHeight: "21px",
        letterSpacing: "0.25px"
    },
    submitButtonWrapper: {
        display: "flex",
        alignSelf: "center"
    }
});

const MessageVerifyDialog = ({ reContactMessageRule, setReContactMessageVerify }) => {
    const classes = useStyles();
    const history = useHistory();
    const { getCustomerData } = useCustomerContext();
    const { message, createMessage, setDialogOpen, generateVerificationCode, setIsMessageOpen } =
        useCustomerMessageContext();
    const { loading } = message;
    const { t } = useTranslation();

    const handleSubmit = () => {
        const customerData = getCustomerData();

        const payload = {
            customerFirstName: customerData.name,
            email: customerData.email
        };

        if (reContactMessageRule === VERIFY) {
            generateVerificationCode(payload, ClientContext._groupName, response => {
                if (response) {
                    setIsMessageOpen(false);
                    setDialogOpen(true);
                    setReContactMessageVerify(true);
                }
            });
        } else {
            const customer = reContactMessageRule === CREATE ? { ...customerData, enforce: true } : customerData;
            setDialogOpen(false);
            createMessage(customer, newMsg => {
                history.push(`/conversation/${newMsg.messageId}/${newMsg.accessKey}/false`);
            });
        }
    };

    const reContactOverlay = (
        <>
            {t(
                "You already have an ongoing conversation with us. We’ve just sent you an email with a link to the previous message"
            )}
            {reContactMessageRule === CREATE || reContactMessageRule === VERIFY ? (
                <>
                    <br />
                    {t("or")}
                </>
            ) : (
                "."
            )}
        </>
    );

    return (
        <div className="llm-view-container">
            <div className={classes.container}>
                <Typography variant="body2" component="div" className={classes.heading}>
                    {reContactOverlay}
                </Typography>
                {(reContactMessageRule === CREATE || reContactMessageRule === VERIFY) && (
                    <div className={classes.submitButtonWrapper}>
                        <SubmitButton
                            title="SUBMIT MY QUESTION ANYWAY"
                            width={250}
                            disabled={loading}
                            handleSubmit={handleSubmit}
                            loading={loading}
                        />
                    </div>
                )}
            </div>
        </div>
    );
};

MessageVerifyDialog.propTypes = {
    reContactMessageRule: PropTypes.string.isRequired,
    setReContactMessageVerify: PropTypes.func.isRequired
};

export default MessageVerifyDialog;
